import React from 'react';
import { QueryStatsOutlined, StyleOutlined } from '@mui/icons-material';
import '../../styles/components/_gamesSelectorToggle.css';

const options = [
  { value: 'games', label: 'BY GAME', Icon: StyleOutlined },
  { value: 'performances', label: 'PERFORMANCES', Icon: QueryStatsOutlined },
];

export default function GamesSelectorToggle({ selectedView, onSelect }) {
  return (
    <div className="games-selector-toggle" role="group" aria-label="Choose game summary view">
      {options.map(({ value, label, Icon }) => {
        const isSelected = selectedView === value;

        return (
          <button
            className={`games-selector-option${isSelected ? ' games-selector-option-active' : ''}`}
            key={value}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onSelect(value)}
          >
            <Icon className="games-selector-icon" aria-hidden="true" />
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}